import React from "react";
import styled from "styled-components";
import Portfolio from "./Portfolio";
import { motion } from "framer-motion";

const Project = () => {
  return (
    <>
      <Psection>
        <p className="phead">Portfolio</p>
        <motion.div className="portfolio" variants={portfolioVariants} initial="hidden" animate="visible">
          <Portfolio />
          <Portfolio />
          <Portfolio />
          <Portfolio />
          <Portfolio />
          <Portfolio />
          </motion.div>
      </Psection>
    </>
  );
};
const Psection = styled.section`

  margin-top: 40px;
  width: 100%;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;

  .phead {
    font-family: "Berkshire Swash", cursive;
    font-size: 2rem;
    margin: 0 auto;
    margin-bottom: 25px;
    color: #fb315a;
    @media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
      font-size: 4rem;
    }
    @media (max-width: 480px) {
      font-size: 2rem;
    }
  }
  .portfolio {
    display: flex;
    gap: 20px;
    justify-content: center;
    flex-wrap: wrap;
  }
`;
const portfolioVariants = {
  hidden: { opacity: 0, x: -50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut",
      staggerChildren: 0.2,
      delayChildren: 0.2,
    },
  },
};
export default Project;
